import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import swal from "sweetalert";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

import { GetLanguageString } from "../../helper/Components";
import { ApiUnit } from "../../unit/ApiUnit";
import { GetSelectedLanguage } from "../../helper/Method";
import { CheckPermission, LoadingSpinner } from "../../../constants/const";
import SelectResponsibilityData from "./SelectResponsibilityData";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { addMember } from "../ApiMember";
import ResponsibilityErrorMessage from "./ResponsibilityErrorMessage";
import Draggable from "react-draggable";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const AddResponsibilityByUnit = ({
  history,
  addNewRafiq,
  unitId,
  loading1,
  memberId,
  setUpdatedDetails,
  addResponsibilityModal,
  setAddResponsibilityModal,
  setResponsibilityStateChange,
  memberTypeId,
}) => {
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [responsibilityValues, setResponsibilityValues] = useState({
    memberId: memberId,
    memberRegNo: 0,
    responsibilityDate: null,
    referenceNote: "",
    displayName: "",
    unit: {
      value: unitId,
      label: "",
    },
    responsibility: {
      value: 0,
      label: "",
      isMultiple: false,
    },
    responsibilityPermissionExists: false,
  });
  const [unitList, setUnitList] = useState([]);
  const [loadings, setLoadings] = useState(loading1);
  const [loading, setLoading] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const { t } = useTranslation();
  const [displayMessageModal, setDisplayMessageModal] = useState(false);
  const notify = (string) => toast.success(string);
  const unitTypeName = "null";
  const [position, setPosition] = useState({ x: 0, y: 0 });

  const handleDrag = (e, ui) => {
    const { x, y } = position;
    setPosition({ x: x + ui.deltaX, y: y + ui.deltaY });
  };

  const toggle = () => {
    setAddResponsibilityModal(false);
  };

  useEffect(() => {
    ApiUnit()
      .getUnitList(unitId, loggedInUnitId, false, unitTypeName)
      .then((res) => {
        setUnitList(res.data);
        setLoadings(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadings(false);
      });
  }, [unitId, loggedInUnitId]);

  const handleChangeUnits = (record) => {
    if (record !== null) {
      ApiUnit()
        .getUnitList(record.value, loggedInUnitId, false, unitTypeName)
        .then((res) => {
          setUnitList(res.data);
        })
        .catch((err) => console.log(err));

      setResponsibilityValues({
        ...responsibilityValues,
        unit: record,
      });
    }
  };

  const [errors, setErrors] = useState({
    responsibilityDate: "",
    responsibility: "",
    displayName: "",
  });

  const validate = () => {
    let temp = {};
    temp.responsibilityDate =
      responsibilityValues.responsibilityDate !== null ? (
        ""
      ) : (
        <GetLanguageString props="member_member_details_responsibility_date_error_message" />
      );

    temp.responsibility =
      responsibilityValues.responsibility.value !== 0 &&
      Object.values(responsibilityValues.responsibility).length !== 0 ? (
        ""
      ) : (
        <GetLanguageString props="member_member_details_responsibility_error_message" />
      );

    if (responsibilityValues.responsibility.isMultiple) {
      temp.displayName =
        responsibilityValues.responsibility.isMultiple &&
        responsibilityValues.displayName !== "" ? (
          ""
        ) : (
          <GetLanguageString props="responsibility_title_err" />
        );
    }

    setErrors({
      ...temp,
    });

    return Object.values(temp).every((x) => x === "");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (!responsibilityValues.responsibility.isMultiple) {
      responsibilityValues.displayName = "";
    }

    const hasPermission = CheckPermission(
      `CanRequestResponsibilityModification${responsibilityValues.responsibility.label}`,
      true
    );

    setButtonDisable(true);
    setLoading(true);

    const proceedWithResponsibility = async () => {
      try {
        const action = hasPermission
          ? addMember().checkIfMemberResponsibilityExists
          : addMember().addMemberResponsibility;

        const res = await action(responsibilityValues, addNewRafiq);
        const { data } = res;

        if (data.requestExists) {
          return swal({
            title: t("member__request_exists_for_assign_responsibility"),
            className: GetSelectedLanguage() === "en" ? "" : "ur",
            icon: "error",
            buttons: GetSelectedLanguage() === "en" ? "OK" : "ٹھیک ہے ",
          });
        }

        if (data.isSuccess) {
          notify(t("member__request_success_for_assign_responsibility"));
          return toggle();
        }

        if (data === "Invalid Data") {
          notify(data);
          return toggle();
        }

        if (data.cannotAssignResponsibility && !data.isMemberMubtadi) {
          return swal({
            title: t(
              "member__member_responsibility_error_cannot_assign_resposnibility"
            ),
            icon: "error",
            buttons: "OK",
            className: GetSelectedLanguage() === "en" ? "" : "ur",
          });
        }

        if (
          !data.thisMemberHaveResponsibility &&
          !data.otherMemberHaveResponsibility &&
          !data.isUsraMavin
        ) {
          if (hasPermission) {
            setAddResponsibilityModal(false);
            history.push({
              pathname: `/member/memberResponsibilityRequest`,
              state: { responsibilityValues },
            });
          } else {
            swal({
              title: t("member__member_responsibility_added_success_message"),
              icon: "success",
              buttons: "OK",
              className: GetSelectedLanguage() === "en" ? "" : "ur",
            });
            setResponsibilityStateChange((prev) => !prev);
            setUpdatedDetails((prev) => !prev);
            toggle();
          }
        } else {
          setErrorMessages(data);
          setDisplayMessageModal(true);
        }
      } catch (err) {
        swal({ title: err.message || "Error", icon: "error", buttons: "OK" });
        console.error(err);
      } finally {
        setLoading(false);
        setButtonDisable(false);
      }
    };

    if (memberTypeId === 1) {
      swal({
        title: t(
          "member__member_responsibility_error_assigning_responsibility_mubtadi"
        ),
        icon: "warning",
        buttons: {
          cancel: {
            text: t("common_cancel"),
            value: false,
            visible: true,
            className: "swal-button--cancel",
          },
          confirm: {
            text: t("common_ok_button"),
            value: true,
            visible: true,
            className: "swal-button--confirm",
          },
        },
        className: GetSelectedLanguage() === "en" ? "" : "ur",
      }).then((confirmed) => {
        if (confirmed) proceedWithResponsibility();
        else toggle();
      });
    } else {
      proceedWithResponsibility();
    }
  };

  return (
    <>
      <Draggable position={position} onDrag={handleDrag} cancel=".no-drag">
        <Modal
          size="lg"
          isOpen={addResponsibilityModal}
          className="inmodal"
          autoFocus={false}
        >
          {displayMessageModal ? (
            <ResponsibilityErrorMessage
              setDisplayMessageModal={setDisplayMessageModal}
              data={errorMessages}
              displayName={responsibilityValues.displayName}
            />
          ) : null}
          <ModalHeader className="modal-title" tag="h4">
            {<GetLanguageString props="settings_add_responsibility" />}
          </ModalHeader>
          <ModalBody>
            {!loading ? (
              !loadings ? (
                <Row>
                  <div className="col-md-12">
                    <Row>
                      <Label className="col-form-label">
                        <GetLanguageString props="member_select_responsibility_unit" />
                      </Label>
                      {unitList.map((record, index) => {
                        const unitOptions = [];
                        record.unitList.forEach((d) =>
                          d.unitTypeName !== "UsraMuavin" &&
                          d.unitTypeName !== "Munfarid" &&
                          d.unitTypeName !== "EX"
                            ? unitOptions.push({ value: d.id, label: d.name })
                            : null
                        );
                        let selected = {};
                        if (record.selectedUnit !== null) {
                          selected = {
                            value: record.selectedUnit.id,
                            label: record.selectedUnit.name,
                          };
                        }

                        const isLastIndex = index === unitList.length - 1;

                        return (
                          <>
                            <Col md="4" key={index}>
                              <FormGroup>
                                <Row>
                                  <Col md="10">
                                    <Select
                                      options={unitOptions}
                                      value={selected}
                                      className="basic-single ur no-drag"
                                      classNamePrefix="select"
                                      isDisabled={
                                        responsibilityValues.responsibilityPermissionExists
                                      }
                                      onChange={handleChangeUnits}
                                    />
                                  </Col>
                                  {isLastIndex ? null : (
                                    <Col md="2" className="p-0">
                                      {GetSelectedLanguage() === "en" ? (
                                        <i className="fa fa-arrow-right fa-lg m"></i>
                                      ) : (
                                        <i className="fa fa-arrow-left fa-lg m"></i>
                                      )}
                                    </Col>
                                  )}
                                </Row>
                              </FormGroup>
                            </Col>
                          </>
                        );
                      })}
                    </Row>
                    <div>
                      <SelectResponsibilityData
                        setValues={setResponsibilityValues}
                        values={responsibilityValues}
                        errors={errors}
                        setErrors={setErrors}
                        selectedUnit={responsibilityValues?.unit?.value}
                        memberId={memberId}
                        type={"add"}
                      />
                    </div>
                  </div>
                </Row>
              ) : (
                LoadingSpinner()
              )
            ) : (
              LoadingSpinner()
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="white" onClick={toggle}>
              {<GetLanguageString props="common_cancel" />}
            </Button>
            <Button
              color="primary"
              disabled={buttonDisable}
              type="submit"
              onClick={handleSubmit}
            >
              {<GetLanguageString props="common_save_changes" />}
            </Button>
          </ModalFooter>
        </Modal>
      </Draggable>
    </>
  );
};

export default withRouter(AddResponsibilityByUnit);
